<template>
	<div
		:class="{
			'sports-list': $store.getters.layout == 'Desktop'
		}"
	>
		<div
			:class="{
				'sports-list__live__sports': $store.getters.layout == 'Mobile',
			}"
				 v-if="loaded && selectedSport && sports.length > 0"
		>
			<router-link
				v-if="!env.disabledFeatures.includes('snapika')"
				:class="{
				'sports-list__item': 1,
				'sports-list__live__sports__item': $store.getters.layout == 'Mobile',
				active: false,
			}"
			:to="{
				name: 'live-snap',
			}"
			>
				<div class="sports-list__item__icon__container">
					<svg class="sports-list__item__icon" style="stroke: var(--main-bg-color);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6.76017 22H17.2402C20.0002 22 21.1002 20.31 21.2302 18.25L21.7502 9.99C21.8902 7.83 20.1702 6 18.0002 6C17.3902 6 16.8302 5.65 16.5502 5.11L15.8302 3.66C15.3702 2.75 14.1702 2 13.1502 2H10.8602C9.83017 2 8.63017 2.75 8.17017 3.66L7.45017 5.11C7.17017 5.65 6.61017 6 6.00017 6C3.83017 6 2.11017 7.83 2.25017 9.99L2.77017 18.25C2.89017 20.31 4.00017 22 6.76017 22Z"/>
						<path d="M10.5 8H13.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12 18C13.79 18 15.25 16.54 15.25 14.75C15.25 12.96 13.79 11.5 12 11.5C10.21 11.5 8.75 12.96 8.75 14.75C8.75 16.54 10.21 18 12 18Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>




				</div>
				<div class="sports-list__item__label">Snap Live Match</div>
				<span class="sports-list__item__count visible-desktop"></span>
			</router-link>
			<router-link
				:class="{
				'sports-list__item': 1,
				'sports-list__live__sports__item': $store.getters.layout == 'Mobile',
				active: isLiveRoot,
			}"
			:to="{
				name: 'live',
			}"
			>
				<div class="sports-list__item__icon__container">
					<svg
						class="sports-list__item__icon"
						viewBox="0 0 15 21"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M8.4375 1.4375C8.4375 2.21875 8.71094 3 9.25781 3.70312C9.57031 4.17188 10.1562 4.83594 11.0938 5.65625C11.9141 6.4375 12.5391 7.0625 12.9297 7.49219C13.5547 8.27344 14.0625 9.01562 14.4141 9.79688C14.8047 10.8125 15 11.8672 15 13C15 14.3672 14.6484 15.6172 13.9844 16.75C13.2812 17.9219 12.3828 18.8203 11.25 19.4844C10.0781 20.1875 8.82812 20.5 7.5 20.5C6.13281 20.5 4.88281 20.1875 3.75 19.4844C2.57812 18.8203 1.67969 17.9219 1.01562 16.75C0.3125 15.6172 0 14.3672 0 13C0 11.9453 0.195312 10.9297 0.664062 9.91406C1.05469 9.09375 1.52344 8.35156 2.14844 7.72656C2.30469 7.53125 2.53906 7.45312 2.8125 7.45312C3.04688 7.45312 3.28125 7.57031 3.47656 7.72656C3.63281 7.88281 3.75 8.11719 3.75 8.39062V11.7109C3.75 12.4141 3.98438 13.0391 4.45312 13.5078C4.92188 14.0156 5.50781 14.25 6.21094 14.25C6.91406 14.25 7.5 14.0156 8.00781 13.5469C8.47656 13.0781 8.75 12.4531 8.75 11.75C8.75 11.2031 8.55469 10.6953 8.20312 10.1875C7.96875 9.875 7.57812 9.44531 7.03125 8.85938C6.25 8.15625 5.74219 7.57031 5.50781 7.10156C5.03906 6.39844 4.88281 5.57812 5.03906 4.67969C5.15625 3.58594 5.70312 2.33594 6.71875 0.929688C6.875 0.695312 7.07031 0.539062 7.38281 0.5C7.65625 0.5 7.89062 0.578125 8.125 0.734375C8.32031 0.890625 8.4375 1.125 8.4375 1.4375Z"
						/>
					</svg>
					<span class="sports-list__item__count visible-mobile">{{
							meta.total
						}}</span>
				</div>
				<div class="sports-list__item__label">{{$t('prebets.all-sports')}}</div>
				<span class="sports-list__item__count visible-desktop">{{
						meta.total
					}}</span>
			</router-link>

			<router-link
				v-show="meta.streamable > 0"
				class="sports-list__item"
				:class="{
				'sports-list__item': 1,
				'sports-list__live__sports__item': $store.getters.layout == 'Mobile',
				active: selectedSport.sport_id == -1,
			}"
				:to="{
				name: 'live-sport',
				params: {
					sportName: 'streamable',
				},
			}"
			>
				<div class="sports-list__item__icon__container">
					<svg
						class="sports-list__item__icon"
						viewBox="0 0 12 8"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M6.9375 0.5C7.19141 0.5 7.40625 0.597656 7.60156 0.773438C7.77734 0.96875 7.875 1.18359 7.875 1.4375V7.0625C7.875 7.33594 7.77734 7.55078 7.60156 7.72656C7.40625 7.92188 7.19141 8 6.9375 8H1.3125C1.03906 8 0.824219 7.92188 0.648438 7.72656C0.453125 7.55078 0.375 7.33594 0.375 7.0625V1.4375C0.375 1.18359 0.453125 0.96875 0.648438 0.773438C0.824219 0.597656 1.03906 0.5 1.3125 0.5H6.9375ZM10.6484 1.24219C10.7656 1.16406 10.9219 1.125 11.0781 1.14453C11.2344 1.16406 11.3516 1.22266 11.4688 1.33984C11.5664 1.45703 11.625 1.57422 11.625 1.73047V6.75C11.625 6.92578 11.5664 7.0625 11.4688 7.17969C11.3516 7.29688 11.2344 7.35547 11.0781 7.375C10.9219 7.39453 10.7656 7.35547 10.6484 7.25781L8.5 5.79297V2.70703L10.6484 1.24219Z"
						/>
					</svg>
					<span class="sports-list__item__count visible-mobile">{{
							meta.streamable
						}}</span>
				</div>
				<span class="sports-list__item__label">{{$t('general.watch-live')}}</span>
				<span class="sports-list__item__count visible-desktop">{{
						meta.streamable
					}}</span>
			</router-link>

			<router-link
				v-for="sport in sports"
				:key="sport.sport_id"
				:class="{
				'sports-list__item': 1,
				'sports-list__live__sports__item': $store.getters.layout == 'Mobile',
				active: selectedSport.sport_id == sport.sport_id,
			}"
				:to="{
				name: 'live-sport',
				params: {
					sportName: $options.filters.seoText(sport.sport_name),
				},
			}"
			>
				<div class="sports-list__item__icon__container">
					<sport-icon class="sports-list__item__icon" :sport="sport" />
					<span class="sports-list__item__count visible-mobile">{{
							sport.count
						}}</span>
				</div>
				<div class="sports-list__item__label">{{ sport.sport_name }}</div>
				<span class="sports-list__item__count visible-desktop">{{
						sport.count
					}}</span>
			</router-link>
		</div>
		<page-error
			v-else-if="loaded && (!selectedSport || sports.length == 0)"
			:message="$t('live.live-sports-not-available')"
			style="padding: 30px; background: var(--white); margin: 0"
			class="visible-desktop"
		>
			<b-button slot="action" :title="$t('general.refresh')" @click="refreshSports" />
		</page-error>
		<div v-else>
			<basic-list-loader class="visible-desktop" />
			<sport-list-loader class="visible-mobile" />
		</div>
	</div>
</template>

<script>
import BasicListLoader from "../Shared/BasicListLoader.vue";
import SportListLoader from "../Shared/SportListLoader.vue";
export default {
	name: "LiveSportsList",
	components: { SportListLoader, BasicListLoader },
	data() {
		return {
			error: false,
			isLiveRoot: false
		};
	},
	beforeMount() {
		let vm = this;
		if(!vm.env.setDefaultLiveRoute){
			this.isLiveRoot = true;
		}else{
			this.isLiveRoot = false;
		}
	},
	methods: {
		refreshSports() {
			let refreshSportsEvent = new Event("refreshSports");
			window.dispatchEvent(refreshSportsEvent);
		},
	},
	computed: {
		selectedSport() {
			return this.$store.getters.liveSelectedSport;
		},
		sports() {
			return this.$store.getters.liveSports.data;
		},
		meta() {
			return this.$store.getters.liveSports.meta;
		},
		loaded() {
			return this.$store.getters.liveSportsLoaded;
		},
	},
	watch: {
		$route: {
			handler: function(){
				let vm = this;
				const routeName = vm.$route.fullPath;
				vm.isLiveRoot = routeName === "/live" ? true : false;
			}
		}
	}
};
</script>
